import { apiClient } from './api.service';

/**
 * Endpoints reachable without a session, driven by links inside emails.
 *
 * Kept out of `api.service.ts`'s authenticated surface because the caller has no token — and in
 * the unsubscribe case, no account at all.
 */
export const publicAuthApi = {
  unsubscribe: (token: string) =>
    apiClient.post<null>('/signup-leads/unsubscribe', { token }).then((r) => r.data),

  acceptInvite: (token: string, password: string) =>
    apiClient.post<null>('/auth/accept-invite', { token, password }).then((r) => r.data),
};
